import React from 'react';
import './App.css';

function Designs({ setCurrentPage }) {
  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' height={40}></img></span>
          </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#designs" onClick={() => setCurrentPage('designs')}>Designs</a>
            <a href="#suppliers" onClick={() => setCurrentPage('suppliers')}>Suppliers</a>
            <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>
      
      <section className="designs-section">
        <div className="container">
          <div className="divider"></div>
          <h2>Designs</h2>
          
          
           
            
            
            <div className="design-item">
              <img src="./design.png" alt="Data Center Design 4" />
            </div>
        
        </div>
      </section>
      
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 StrataCore Technology FZ LLC</span>
            <span>Powered by StrataCore Technology FZ LLC</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Designs;